import React from "react";
import { Box } from "@mui/material";
import { colors, typography, borderRadius } from "../../theme/tokens";

const TAG_COLORS: Record<string, string> = {
  プレスリリース: colors.primary[600],
  お知らせ: colors.semantic.info,
  イベント: colors.accent.emerald,
  採用: colors.accent.violet,
};

interface TagChipProps {
  label: string;
  color?: string;
}

export const TagChip: React.FC<TagChipProps> = ({ label, color }) => {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        height: "24px",
        px: "10px",
        borderRadius: borderRadius.full,
        backgroundColor: color || TAG_COLORS[label] || colors.neutral[600],
        color: colors.neutral[0],
        fontSize: typography.fontSize.xs,
        fontWeight: typography.fontWeight.medium,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </Box>
  );
};
